export default {"src":"/_next/static/media/0x853d955acef822db058eb8505911ed77f175b99e.668df216.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};